import t from"./tailwind.js";import s from"@tailwindcss/forms";const{theme:e}=t;var i={plugins:[s],content:["{src,styleguide}/**/*.{md,ts,tsx,css}"],theme:e};export{i as default};
